import {createTheme} from "@material-ui/core/styles"
import {gtBlue, gtGreen, gtGray, primary2Pallete} from "./colorConstants"

const MuiAppBar = {
  colorPrimary: {
    backgroundColor: gtGray,
    color: "white",
  },
}
const MuiButton = {
  root: {
    borderRadius: 2,
    fontWeight: "bold",
    height: 40,
    textTransform: "capitalize",
    fontSize: 14,
  },
  contained: {
    color: "white",
    backgroundColor: gtBlue,
    "&:hover": {
      backgroundColor: "#2e73ab",
    },
  },
  outlinedPrimary: {
    backgroundColor: "white",
    borderColor: primary2Pallete["1"],
    border: "solid 1px",
    color: gtBlue,
  },
  textPrimary: {
    color: "red",
  },
}

const buttonBase = {
  font: "var(--font-weight-semibold) var(--font-size-paragraph-large) / 150% var(--secondary-font-family)",
  display: "flex",
  padding: "10px 16px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "var(--border-radius)",
  gap: "12px",
  border: "none",
  height: "var(--action-item-height)",
  cursor: "pointer",
}

const buttonGreen = {
  ...buttonBase,
  backgroundColor: "var(--modes-primary)",
  color: "var(--modes-on-primary-container)",
  "&:hover": {
    backgroundColor: "var(--color-primitives-evergreen-evergreen50)",
    color: "var(--color-primitives-evergreen-evergreen30)",
  },
  "&:active": {
    backgroundColor: "var(--color-primitives-evergreen-evergreen30)",
    color: "var(--color-on-primary)",
  },
}

const skinWhite = {
  ...buttonBase,
  background: "var(--modes-background)",
  color: "var(--modes-on-primary-container)",
  border: "1px solid var(--modes-primary)",
  "&:hover": {
    color: "var(--color-primitives-evergreen-evergreen30)",
    backgroundColor: "transparent",
    border: "1px solid var(--color-primitives-evergreen-evergreen50)",
  },
  "&:active": {
    color: "var(--color-primitives-evergreen-evergreen20)",
    border: "1px solid var(--color-primitives-evergreen-evergreen30)",
  },
  "&.selected": {
    background: "var(--color-primary-container)",
  },
}

const buttonTertiaryGreen = {
  ...buttonBase,
  backgroundColor: "var(--modes-background)",
  color: "var(--modes-on-primary-container)",
  boxShadow: "none",
  padding: "0px",
  paddingLeft: "8px",
  margin: "0",
  "&:hover": {
    color: "var(--color-primitives-evergreen-evergreen30)",
    backgroundColor: "transparent",
  },
  "&:active": {
    color: "var(--color-primitives-evergreen-evergreen20)",
  },
}

const MuiChip = {
  root: {
    borderRadius: "var(--border-radius)",
    border: "1px solid var(--modes-primary)",
    backgroundColor: "var(--modes-background)",
    padding: "10px 8px",
    height: "var(--action-item-height)",
    color: "var(--color-secondary)",
    fontFamily: "var(--secondary-font-family)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-semibold)",
    lineHeight: "150%",
    margin: "4px !important",
    columnGap: "8px",
    maxWidth: "calc(100% - 16px) !important",
    "& .MuiChip-label": {
      padding: "0px",
    },
    "&:hover": {
      color: "var(--color-primitives-evergreen-evergreen30)",
      border: "1px solid var(--color-primitives-evergreen-evergreen50)",
    },
  },
  deleteIcon: {
    height: "var(--icon-size)",
    width: "var(--icon-size)",
    margin: "0px",
    deleteIcon: {
      marginRight: "12px",
      color: "var(--modes-on-primary-container)",
      "&:hover": {
        color: "var(--color-primitives-evergreen-evergreen30)",
      },
    },
  },
}

const MuiAutocomplete = {
  option: {
    padding: "0px",
    marginBottom: "4px",
    color: "var(--modes-on-primary-container)",
    fontFamily: "var(--primary-font-family)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "var(--line-height)",
    borderRadius: "2px",
    paddingLeft: "8px",
    "&:hover": {
      backgroundColor: "var(--modes-primary-container)",
    },
    "&:focus": {
      backgroundColor: "var(--modes-primary-container) !important",
    },
    '&[aria-selected="true"]': {
      backgroundColor: "var(--modes-primary) !important",
      fontWeight: "var(--font-weight-bold)",
    },
    '&[aria-disabled="true"]': {
      color: "var(--modes-primary)",
      opacity: "0.8",
      cursor: "not-allowed",
    },
  },
  paper: {
    padding: "8px",
    borderRadius: "var(--border-radius)",
    border: "1px solid var(--modes-outline)",
    "& .MuiAutocomplete-listbox": {
      padding: "0",
    },
    "& .MuiAutocomplete-option": {
      padding: "8px",
    },
    "& .MuiAutocomplete-option[data-focus='true']": {
      background: "var(--modes-primary-container)",
    },
  },
}

const MuiInputBase = {
  input: {
    color: "#4A4A4A",
    fontSize: 14,
  },
}

const MuiOutlinedInput = {
  root: {
    borderColor: "#000",
  },
  input: {
    borderColor: "#000",
  },
}

const MuiSvgIcon = {
  root: {
    color: "#E3E3E3",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}
// MuiChip-deleteIcon MuiChip-deleteIconSmall

const MuiIconButton = {
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}

const MuiMenuItem = {
  root: {
    fontSize: 14,
    "&$selected": {
      backgroundColor: "#FFF",
      fontWeight: "bold",
    },
  },
}

const MuiSelect = {
  root: {
    width: 400,
    height: 32,
    color: "#4A4A4A",
    fontSize: 14,
  },
  select: {
    height: 32,
    "&:focus": {
      backgroundColor: "#FFF",
    },
  },
  icon: {
    color: "#E3E3E3",
  },
}

const customTheme = {
  palette: {
    primary: {
      main: gtBlue,
    },
    secondary: {
      main: gtGreen,
    },
  },
  typography: {
    fontFamily: "akku",
  },
  overrides: {
    MuiAppBar,
    MuiButton,
    MuiChip,
    MuiSelect,
    MuiInputBase,
    MuiMenuItem,
    MuiAutocomplete,
    MuiSvgIcon,
    MuiOutlinedInput,
    MuiIconButton,
    buttonGreen,
    skinWhite,
    buttonTertiaryGreen,
  },
  props: {
    MuiButtonBase: {
      disableRipple: true, // No more ripple, on the whole application!
    },
  },
}
export const gtTheme = createTheme(customTheme)
